import { useContext } from "react";
import TransferCheck from "./TransferCheck";
import { STEP_SCHEDULE_PHONE_CALL } from "../../class/transferDetails";
import { TransferContext } from "../../context/TransferContext";
import { AppContext } from "../../context/AppContext";
import { BRIDGE_DEMO } from "../../typings";

const PostTransfer = () => {
  const { appEnv } = useContext(AppContext);
  const { goToScreen, navigateToHomeScreen, isPhoneCallNeeded, transferIntentDetails } = useContext(TransferContext);

  // need to check if schedule call is needed
  const onNextHandler = () => {
    if (isPhoneCallNeeded) {
      goToScreen(STEP_SCHEDULE_PHONE_CALL);
    } else {
      navigateToHomeScreen();
    }
  };
  return (
    <TransferCheck
      onNext={onNextHandler}
      phoneCallNeeded={appEnv === BRIDGE_DEMO ? false : !!transferIntentDetails?.transferAccount?.accountNumber}
    />
  );
};
export default PostTransfer;
